import { Checkbox } from "baseui/checkbox";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import enums from "../../utils/enums";
import { Spinner } from "baseui/spinner";
import { useNavigate, useParams } from "react-router-dom";
import request from "../../utils/http";
import { DateTime } from "luxon";
import { Button } from "baseui/button";
import { AppContextValue } from "../../AppContext";
import toaster from "../../utils/toaster";

const Container = styled.div`
	> div {
		margin-bottom: 1rem;
	}

	em {
		font-weight: normal;
	}
`;

const ActionContainer = styled.div`
	margin-left: 2rem;
	margin-top: 0.5rem;
	margin-bottom: 0.5rem;
`;

const CandidateInternalTasks = (props: any) => {
	const navigate = useNavigate();
	const urlParams = useParams() as any;

	const [candidateId, setCandidateId] = useState("");
	const [pilAccess,setPILAccess] = useState(Boolean);


	const [loading, setLoading] = useState(true);
	const [internalTaskData, setInternalTaskData] = useState({} as any);
	const [internalTaskEnum, setInternalTaskEnum] = useState([] as any);
	const [sendToZambionPerm, setSendToZambionPerm] = useState(false);

	const onTaskChange = (slug: string, name: string, value: boolean) => {
		let tmpInternalTaskData = { ...internalTaskData };
		tmpInternalTaskData[slug] = tmpInternalTaskData[slug] ?? {};
		tmpInternalTaskData[slug].complete = value;
		tmpInternalTaskData[slug].loading = true;
		setInternalTaskData(tmpInternalTaskData);
		saveTaskState(slug, name, value);
	};
	const perms=AppContextValue.state.auth.permissions;

	// const loadPILAccess = async () => {
	// 	let result = await request(
	// 		"GET",
	// 		`/api/admin/utility/pil-permission-get`,
	// 		null
	// 	);
	// 	if (result.success && result.data) {
	// 		if(!result.data.pilAccess)
	// 		{
	// 			toaster.error("You don't have permission to create a PIL candidate");
	// 		}
	// 		setPILAccess(result.data.pilAccess);
	// 	}
	// };
	// useEffect(() => {
	// 	loadPILAccess();
	// }, []);

	const getData = async () => {
		let result = await request(
			"GET",
			`/api/admin/internal-tasks/list/${candidateId}`,
			null,
			true,
			true
		);
		if (result.success && result.data) {
			processResults(result.data);
		}
		setLoading(false);
	};

	const saveTaskState = async (slug: string, name: string, value: boolean) => {
		let result = await request(
			"POST",
			`/api/admin/internal-tasks/save/${candidateId}`,
			{
				slug,
				name,
				complete: value,
			},
			true,
			true
		);
		if (result.success && result.data) {
			processResults(result.data);
		}
	};

	const processResults = (data: any) => {
		setInternalTaskData(data.tasks);
		setInternalTaskEnum([...enums.internalTasks]);
	};

	const updateUrlParams = async () => {
		setCandidateId(urlParams.candidateId);
	};

	useEffect(() => {
		if (candidateId != "") {
			getData();
			perms.includes("admin>candidate>zambion")? setSendToZambionPerm(true):setSendToZambionPerm(false);
		}
	}, [candidateId]);

	useEffect(() => {
		// loadPILAccess();
		updateUrlParams();

	}, [urlParams, updateUrlParams]);

	return (
		<>
			{loading ? (
				<Spinner />
			) : (
				<Container>
					{internalTaskEnum.map((task: any) => {
						const thisTask = internalTaskData[task.slug];
						if(!sendToZambionPerm && task.slug === "zambion")
						{
							return(<div></div>);
						}

						return (
							<div>
								<Checkbox
									checked={thisTask?.complete ?? false}
									onChange={
										props.readOnly
											? () => {}
											: (e: any) =>
													onTaskChange(task.slug, task.name, e.target.checked)
									}
								>
									{task.label}{" "}
									{thisTask?.complete && (
										<em>
											&nbsp;&nbsp;&nbsp;&nbsp; ({thisTask?.lastModifiedBy},{" "}
											{DateTime.fromISO(thisTask.lastModifiedUtc, {
												zone: "utc",
											})
												.setZone("Pacific/Auckland")
												.toLocaleString(DateTime.DATETIME_MED)}
											,{" "}
											{DateTime.fromISO(thisTask.lastModifiedUtc, {
												zone: "utc",
											})
												.setZone("Pacific/Auckland")
												.toRelative()}
											)
										</em>
									)}
									{thisTask?.loading && (
										<>
											&nbsp;&nbsp;&nbsp;&nbsp;
											<Spinner size={14} />
										</>
									)}{" "}
									{task.notes && (
										<>
											<br />
											<small>{task.notes}</small>
										</>
									)}
								</Checkbox>
								{task.slug === "completed-offer" && (
									<ActionContainer>
										<Button
											size="compact"
											onClick={() => {
												navigate(`/candidate-offer/${candidateId}`);
											}}
										>
											Manage Job Offer
										</Button>
									</ActionContainer>
								)}
								{sendToZambionPerm && task.slug === "zambion" && (
									<ActionContainer>
										<Button
											size="compact"
											onClick={() => {
												navigate(`/candidate-zambion/${candidateId}`);
											}}
										>
											Send Candidate to Zambion
										</Button>
									</ActionContainer>
								)}
							</div>
						);
					})}
				</Container>
			)}
		</>
	);
};
export default CandidateInternalTasks;